import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";
import React from "react";

export const DisconnectIcon = ({
  width = "24",
  height = "24",
  color = "#E50505",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5306_15260)">
          <path
            d="M18.6818 5.32202C16.9191 3.55933 14.0667 3.55933 12.3061 5.32202L10.2871 7.34099L11.3498 8.40361L13.3687 6.38464C14.4897 5.26368 16.3816 5.14492 17.6192 6.38464C18.8589 7.62436 18.7402 9.51415 17.6192 10.6351L15.6002 12.6541L16.6649 13.7188L18.6839 11.6998C20.4424 9.93711 20.4424 7.08471 18.6818 5.32202ZM10.6372 17.6192C9.51623 18.7402 7.62436 18.8589 6.38672 17.6192C5.147 16.3795 5.26576 14.4897 6.38672 13.3687L8.40569 11.3498L7.34099 10.2851L5.32202 12.304C3.55933 14.0667 3.55933 16.9191 5.32202 18.6797C7.08471 20.4403 9.93711 20.4424 11.6977 18.6797L13.7167 16.6608L12.6541 15.5981L10.6372 17.6192ZM6.75759 5.69706C6.72627 5.66604 6.68396 5.64864 6.63987 5.64864C6.59579 5.64864 6.55348 5.66604 6.52215 5.69706L5.69706 6.52215C5.66604 6.55348 5.64864 6.59579 5.64864 6.63987C5.64864 6.68396 5.66604 6.72627 5.69706 6.75759L17.2483 18.3089C17.3129 18.3735 17.4192 18.3735 17.4838 18.3089L18.3089 17.4838C18.3735 17.4192 18.3735 17.3129 18.3089 17.2483L6.75759 5.69706Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_5306_15260">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
};
